export interface MFEContext {
  location: UserLocation;
}

export enum UserLocation {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}
